/* eslint-disable no-nested-ternary */
import { Avatar, Backdrop, Button, Typography } from '@mui/material';
import styles from './styles';
import { UserAvatarProps } from './types';

const UserAvatar = ({
    size,
    radius,
    name = '',
    source,
    fontSize = 12,
    isEditing = false,
    handleChangeAvatar,
    bgColor = '',
    id = '',
}: UserAvatarProps) => {
    const nameArray = name ? name.split(' ') : [];
    let initial = '';
    if (nameArray.length > 1) {
        initial = nameArray[0].charAt(0) + nameArray[1].charAt(0);
    } else {
        initial = name.substring(0, 2);
    }

    return (
        <>
            {isEditing ? (
                <Backdrop open sx={styles.backdrop(source, size, radius)} key={initial}>
                    <Button variant="text" component="label">
                        <Avatar id={id} src="./images/upload.svg" alt="upload" />
                        <input
                            accept=".jpg, .jpeg, .png"
                            type="file"
                            hidden
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                if (handleChangeAvatar) {
                                    handleChangeAvatar(e);
                                }
                            }}
                        />
                    </Button>
                </Backdrop>
            ) : source ? (
                <Avatar
                    id={id}
                    sx={styles.imageStyle(size, radius)}
                    alt="Profile Initials Image"
                    src={source as unknown as string}
                    key={initial}
                />
            ) : name.length > 0 ? (
                <Typography id={id} key={initial} sx={styles.initialText(size, radius, fontSize, bgColor)}>
                    {initial}
                </Typography>
            ) : null}
        </>
    );
};

export default UserAvatar;
